import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
const DashboardHintCardContent = observer(({ description, links, logo })=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !!logo && /*#__PURE__*/ _jsx("img", {
                src: logo,
                style: {
                    maxWidth: "100%",
                    maxHeight: "80px",
                    display: "block",
                    margin: "0 0 10px"
                }
            }),
            !!description && /*#__PURE__*/ _jsx("p", {
                className: "description",
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            links?.map(({ link, linkText })=>/*#__PURE__*/ _jsx("a", {
                    href: link,
                    target: "_blank",
                    rel: "noreferrer",
                    className: "button",
                    style: {
                        marginTop: 13,
                        marginRight: 10
                    },
                    children: linkText
                }, link))
        ]
    });
});
export { DashboardHintCardContent };
